import { type DefaultIngestionRule } from "@/shared/domain/ingestionRules";
import { Checkbox, Spinner } from "@/shared/foundation/primitives";

import styles from "./DefaultRuleChoices.module.css";

/**
 * Checkboxes for which of Roboto's default ingestion rules the org starts
 * with. A rule the org already has is disabled. Renders nothing when there are
 * no rules or they failed to load.
 */
export function DefaultRuleChoices({
  rules,
  isLoading,
  picked,
  onPickedChange,
}: {
  rules: readonly DefaultIngestionRule[] | undefined;
  isLoading: boolean;
  picked: readonly string[] | undefined;
  onPickedChange: (picked: string[]) => void;
}) {
  if (isLoading) {
    return <Spinner />;
  }
  if (rules === undefined || picked === undefined || rules.length === 0) {
    return null;
  }
  return (
    <div className={styles.choices} data-testid="default-rule-choices">
      <Checkbox.Group
        legend="Ingest these files as they’re uploaded"
        description="Creates ingestion rules you can change, or add to, in Settings → Ingestion."
        value={[...picked]}
        onValueChange={onPickedChange}
      >
        {rules.map((rule) => (
          <Checkbox
            key={rule.name}
            value={rule.name}
            label={rule.name}
            description={
              <code className={styles.patterns}>
                {rule.include_patterns.join(", ")}
              </code>
            }
            disabled={rule.already_present}
            title={
              rule.already_present
                ? "Your organization has this rule"
                : undefined
            }
          />
        ))}
      </Checkbox.Group>
    </div>
  );
}
